import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudMenuModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { FreudScrollPanelModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { CircleComponentModule } from 'shared/components/circle/circle.module';

import { NotificationsListComponent } from './notifications-list.component';

@NgModule({
	declarations: [NotificationsListComponent],
	exports: [NotificationsListComponent],
	providers: [],
	imports: [
		CommonModule,
		TranslateModule,
		FreudTypographyModule,
		FreudMenuModule,
		CircleComponentModule,
		FreudScrollPanelModule,
	],
})
export class NotificationsListModule {}
